import { Navigate, Outlet, useLocation } from 'react-router'

interface ProtectedRouteProps {
  element?: any
}

const ProtectedRoute = ({ element: Element }: ProtectedRouteProps) => {
  let loginFlag = localStorage.getItem('isLoggedIn')
  const location = useLocation()

  if (!loginFlag) {
    return (
      <Navigate
        to="/auth/login"
        state={{
          ...location.state,
          from: location.pathname,
        }}
      />
    )
  }
  return Element ? <Element /> : <Outlet />
}

export default ProtectedRoute
